import { useCallback } from 'react';
import { transform } from 'ol/proj';
import { useGotoEventFetch } from '@ais-ui/websockets';
import { smartZoomTo, useOpenLayersContext } from '@ais-ui/react-openlayers';

/**
 * Returns a function that pans/zooms the map to a detected event's location.
 *
 * Shared by the event "Show event" kebab action and the toast-driven focus
 * navigation so both behave identically (single source of truth).
 */
export const useGotoEvent = (): ((eventId: string) => Promise<void>) => {
  const { map, displayProjection, dataProjection } = useOpenLayersContext();
  const gotoEventFetch = useGotoEventFetch();

  return useCallback(
    async (eventId: string) => {
      const gotoEventData = await gotoEventFetch(eventId);

      const transformedCenter = transform(
        [gotoEventData.lon, gotoEventData.lat],
        dataProjection,
        displayProjection,
      );

      smartZoomTo({ coordinate: transformedCenter, map });
    },
    [gotoEventFetch, map, dataProjection, displayProjection],
  );
};
